import { Link } from "react-router-dom";
import { MapPin, Briefcase, ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/site/Reveal";

export const JobCard = ({ job, index = 0 }) => (
  <FadeUp delay={Math.min(index * 0.08, 0.4)}>
    <Link
      to={`/careers/${job.id}`}
      data-testid={`job-card-${job.id}`}
      className="group block h-full rounded-2xl border border-slate-200 bg-white p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-brand/50 hover:shadow-glow-sm"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-brand">{job.industry}</p>
          <h3 className="mt-3 font-display text-xl font-semibold tracking-tight text-slate-900 transition-colors duration-300 group-hover:text-brand">{job.title}</h3>
          <p className="mt-1 text-sm font-medium text-slate-500">{job.company}</p>
        </div>
        <ArrowUpRight
          size={20}
          className="shrink-0 text-slate-300 transition-[color,transform] duration-300 group-hover:text-brand group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-slate-500">
        <span className="flex items-center gap-1.5"><MapPin size={13} className="text-brand/70" /> {job.location}</span>
        <span className="flex items-center gap-1.5"><Briefcase size={13} className="text-brand/70" /> {job.type}</span>
        {job.experience && <span>{job.experience}</span>}
        {job.salary && <span className="font-semibold text-slate-700">{job.salary}</span>}
      </div>
    </Link>
  </FadeUp>
);
